import React from "react";
import Call from "../../../hocs/call";
import {connect} from "react-redux";
import ArtefactList from "../../../components/artefact-list";
import {
  createHierarchicalCodelistsHierarchicalCodelist,
  deleteHierarchicalCodelistsHierarchicalCodelist,
  deleteHierarchicalCodelistsSelectedHierarchicalCodelists,
  hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren,
  readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren,
  readHierarchicalCodelistsListHierarchicalCodelists,
  showHierarchicalCodelistsHierarchicalCodelistClone,
  editHierarchicalCodelistsHierarchicalCodelistDetail,
  showHierarchicalCodelistsHierarchicalCodelistDownload,
  showHierarchicalCodelistsHierarchicalCodelistExport,
  showHierarchicalCodelistsHierarchicalCodelistExportList
} from "./actions";
import { showArtefactFullExport } from "../../../redux-components/redux-artefact-full-export/actions";

const mapStateToProps = state => ({
  hierarchicalCodelists: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelists,
  parentsAndChildren: state.scenes.metaManager.hierarchicalCodelists.parentsAndChildren
});

const mapDispatchToProps = dispatch => ({
  fetchHierarchicalCodelists: () => dispatch(readHierarchicalCodelistsListHierarchicalCodelists()),
  onHierarchicalCodelistCreate: () => 
    dispatch(createHierarchicalCodelistsHierarchicalCodelist()),
  onHierarchicalCodelistDetail: hierarchicalCodelistTriplet => 
    dispatch(editHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelistTriplet)),
  onDelete: hierarchicalCodelistTriplet => dispatch(deleteHierarchicalCodelistsHierarchicalCodelist(hierarchicalCodelistTriplet)),
  onSelectedHierarchicalCodelistsDelete: hierarchicalCodelistTriplets => 
    dispatch(deleteHierarchicalCodelistsSelectedHierarchicalCodelists(hierarchicalCodelistTriplets)),
  fetchParentsAndChildren: (artefactType, artefactTriplet) =>
    dispatch(readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren(artefactType, artefactTriplet)),
  onParentsAndChildrenHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren()),
  onCloneShow: artefactTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet)),
  onDownloadShow: (hierarchicalCodelistTriplets, lang) => 
    dispatch(showHierarchicalCodelistsHierarchicalCodelistDownload(hierarchicalCodelistTriplets, lang)),
  onExportShowList: artefactIdentity => dispatch(showArtefactFullExport(artefactIdentity)),
});

const HierarchicalCodelistsList = ({
                                     hierarchicalCodelists,
                                     onHierarchicalCodelistCreate,
                                     fetchHierarchicalCodelists,
                                     onHierarchicalCodelistDetail,
                                     onDelete,
                                     onSelectedHierarchicalCodelistsDelete,
                                     onDownloadShow,
                                     parentsAndChildren,
                                     fetchParentsAndChildren,
                                     onParentsAndChildrenHide,
                                     onCloneShow,
                                     onExportShow,
                                     onExportShowList
                                   }) => {

    return (
      <Call 
        cb={fetchHierarchicalCodelists} 
        disabled={hierarchicalCodelists !== null}
      >
          <ArtefactList
            artefacts={hierarchicalCodelists}
            onCreate={() => onHierarchicalCodelistCreate()}
            onDetailShow={triplet => onHierarchicalCodelistDetail(triplet)}
            onDownloadShow={onDownloadShow}
            onDelete={onDelete}
            onSelectedItemDelete={onSelectedHierarchicalCodelistsDelete}
            parentsAndChildren={parentsAndChildren}
            fetchParentsAndChildren={triplet => fetchParentsAndChildren("hierarchicalCodelist", triplet)}
            onParentsAndChildrenHide={onParentsAndChildrenHide}
            showImportButton
            onCloneShow={onCloneShow}
            onExportShow={onExportShow}
            onExportShowList={onExportShowList}
          />
      </Call>
    )
 };
  

export default connect(mapStateToProps, mapDispatchToProps)(HierarchicalCodelistsList);
